const colors = {
  background: '#EAF9FF',
  panel: '#FFFFFF',
  card: '#DDF3FF',
  textPrimary: '#12337A',
  textSecondary: '#5F72A9',
  accent: '#FF5CA8',
  accentSoft: '#FFE3F1',
  border: '#BEE8FF',
  button: '#FF5CA8',
  buttonText: '#FFFFFF',
  danger: '#FF6B6B',
  ink: '#143A8C',
  muted: '#8EA4D8',
  tertiary: '#FFF0A8',
  sky: '#39BFFF',
  blue: '#0069FF',
  yellow: '#FFD447',
  green: '#5DDA7C',
  orange: '#FF9F1C',
  purple: '#8B5CFF',
};

export default colors;
